module.exports = __webpack_public_path__ + "static/img/znzz4.f1caa82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znzz4.jpg
// module id = sPJq
// module chunks = 0